<label fxFlex="35" class="secondary">{{ field.header }}</label>
<label [fxFlex]="field.cell2 ? 33 : 65" *ngIf="entity">
  <span [ngStyle]="styleObject()">

    <ng-container *ngIf="field.cellFlag && field.cellFlag(entity)"> <!-- icon needs to be a function -->
      <flag-icon country="{{ field.cellFlag(entity)?.toLowerCase() }}"></flag-icon>
    </ng-container>


    <ng-container *ngIf="field.icon && field.icon(entity)"> <!-- icon needs to be a function -->
      <ng-container *ngIf="field.link && field.link(entity); else noLinkIcon">
      <a [routerLink]="field.link(entity)" [queryParams]="field.queryParams ? field.queryParams(entity) : {}">
        <mat-icon [ngStyle]="field.iconColor && field.iconColor(entity) ? {'color': field.iconColor(entity)}:{}" style="vertical-align: middle">{{ field.icon(entity) }}</mat-icon>
      </a>
    </ng-container>
    <ng-template #noLinkIcon>
      <mat-icon [ngStyle]="field.iconColor && field.iconColor(entity) ? {'color': field.iconColor(entity)}:{'color': 'black'}" style="vertical-align: middle">{{ field.icon(entity) }}</mat-icon>
    </ng-template>

    </ng-container>
    <ng-container *ngIf="field.link && field.link(entity); else noLink">
      <ng-container *ngIf="field.isExternalLink">
        <a [href]="field.link(entity) + getQueryParamsString(field)">
          {{ field.cell(entity) }}
        </a>
      </ng-container>
      <ng-container *ngIf="!field.isExternalLink"> <!-- internal link -->
        <a [routerLink]="field.link(entity)" [queryParams]="field.queryParams ? field.queryParams(entity) : {}">
          {{ field.cell(entity) }}
      </a>
      </ng-container>

    </ng-container>
    <ng-template #noLink>

      <ng-container *ngIf="isBoolean(field)">

        <ng-container *ngIf="field.cell(entity) === 'true'">
          <i class="material-icons">check</i>
        </ng-container>

        <ng-container *ngIf="field.cell(entity) !== 'true'">
          <i class="material-icons">close</i>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="!isBoolean(field)">
        {{ field.cell(entity) }}
      </ng-container>


    </ng-template>

    <span *ngIf="entity && field.copyCellActive && field.copyCellActive(entity)"><mat-icon style="cursor: pointer; font-size: 1em;" (click)="copyToClipboard()">content_copy</mat-icon></span>

  </span>
</label>

<label [fxFlex]="field.cell2 ? 32 : 0" *ngIf="entity && field.cell2">
  <span [ngStyle]="field.cell2Color && field.cell2Color(entity) ? {'color': field.cell2Color(entity)}:{'color': 'black'}">

    <ng-container *ngIf="field.link2 && field.link2(entity); else noLink2">
      <a [routerLink]="field.link2(entity)" [queryParams]="field.queryParams2 ? field.queryParams2(entity) : {}">
        {{ field.cell2(entity) }}
      </a>
    </ng-container>
    <ng-template #noLink2>
      {{ field.cell2(entity) }}
    </ng-template>
  </span>
</label>
